export default __webpack_public_path__ + "static/media/Logo_YALO_med.a5f2f04c.gif";